export var ACTION_TYPE = {
    Initialize: 'initialize',
    LoadMachineInformation: 'loadMachineInformation',
    CreateMachineRegistration: 'createMachineRegistration',
    ValidateAndAddAttachment: 'validateAndAddAttachment',
    ResetMachine: 'resetMachine',
    Reset: 'reset'
};
